import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { todaysDate } from "../../util/getTodaysDate";
import { objectBuilderForPDF } from "../../util/data.util";
import SecondaryButton from "../buttons/SecondaryButton";
import { TextField } from "@mui/material";
import { downloadFertilityLetter } from "../../util/letterCreation/p4FertilityLetterPdf";
import PrimaryButton from "../buttons/PrimaryButton";
import { loading, doneLoading } from "../../redux/slice/loaderSlice";
import {
  LETTER_MAX_LENGTH,
  P4_FERTILITY_LETTER,
  SNACKBAR_ERROR,
  SNACKBAR_SUCCESS,
} from "../../constants/Constants";
import { activateSnackbar } from "../../redux/slice/snackbarSlice";
import {
  LETTER_DOWNLOAD_SUCCESS,
  LETTER_SAVE_FAILED,
  LETTER_SAVE_SUCCESS,
} from "../../constants/SnackbarMessages";
import { createLetter } from "../../apis/letter";
import CharacterCount from "../fromComponents/CharacterCount";
import { setProgressNotes } from "../../redux/slice/progressNotesSlice";
import AddDownload from "../OptionsComponents/AddDownload";

export const P4PregnancyLetter = React.memo(() => {
  const patientObject: any = useSelector<PatientState>(
    (state) => state.patient
  );
  const { patient } = patientObject;

  const partnerObject: any = useSelector<PartnerState>(
    (state) => state.partner
  );
  const { partner } = partnerObject;
  const userObject: any = useSelector<UserState>((state) => state.user);
  const { signature } = userObject.user.staff;
  const [getSignature, setGetSignature] = useState(signature);
  const [letterObj, setLetterObj] = useState<P4LetterType | null>(null);
  const [content, setContent] = useState<string | null>(null);
  const [isDisable, setIsDisable] = useState(true);
  const [characterCount, setCharacterCount] = useState(0);
  const progressNotes: any = useSelector<ProgressNotesState>(
    (state) => state.progressNotes
  );
  const dispatch = useDispatch();

  const onSubmit = async () => {
    setLetterObj(
      objectBuilderForPDF(patient, partner, {
        content: content,
        letterDate: todaysDate(),
        signature: getSignature,
      })
    );
  };

  const handleDownload = async () => {
    if (letterObj) {
      await downloadFertilityLetter(letterObj);
      dispatch(
        activateSnackbar({
          active: true,
          message: LETTER_DOWNLOAD_SUCCESS,
          variant: SNACKBAR_SUCCESS,
        })
      );
    } else {
      console.log("first");
    }
  };

  const handleSaveLetter = async () => {
    if (letterObj && content && (signature || letterObj.signature)) {
      dispatch(loading());
      let req: P4LetterRequest = {
        name: P4_FERTILITY_LETTER,
        patientPublicId: letterObj.patientId,
        signature: letterObj.signature || signature,
        content: content,
        type: P4_FERTILITY_LETTER,
      };
      const [response, error] = await createLetter(req);
      if (response) {
        dispatch(
          activateSnackbar({
            active: true,
            message: LETTER_SAVE_SUCCESS,
            variant: SNACKBAR_SUCCESS,
          })
        );
        dispatch(setProgressNotes([...progressNotes.data, response]));
        setIsDisable(false);
      } else {
        dispatch(
          activateSnackbar({
            active: true,
            message: LETTER_SAVE_FAILED,
            variant: SNACKBAR_ERROR,
          })
        );
        setIsDisable(true);
      }

      dispatch(doneLoading());
    } else {
      dispatch(
        activateSnackbar({
          active: true,
          message: "Please provide signature",
          variant: SNACKBAR_ERROR,
        })
      );
    }
  };

  const handleReset = () => {
    setIsDisable(true);
    setLetterObj(null);
    setContent(null);
    setGetSignature(null);
  };

  useEffect(() => {
    if (letterObj) {
      handleSaveLetter();
    }
  }, [letterObj]);

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setContent(text);
  };

  return isDisable ? (
    <>
      <div className="col-sm-12 ">
        <div className="col-sm-12 p-2">
          <div className="row ms-1">
            <TextField
              className="col-sm-12 p-2"
              label="Write your letter here..."
              sx={{ my: 1 }}
              value={content}
              required
              minRows={10}
              multiline
              inputProps={{ maxLength: LETTER_MAX_LENGTH }}
              onChange={handleContentChange}
            />
            {content && (
              <CharacterCount value={content} maxCount={LETTER_MAX_LENGTH} />
            )}
            <TextField
              className="col-sm-12 p-2"
              label="Add signature"
              sx={{ my: 1 }}
              value={getSignature}
              minRows={2}
              multiline
              onChange={(e) => {
                setGetSignature(e.target.value);
              }}
            />
          </div>
        </div>

        <PrimaryButton
          label={"Save"}
          type={"button"}
          disable={content ? false : true}
          onClick={onSubmit}
          className={""}
        />
      </div>
    </>
  ) : (
    <AddDownload onDownload={handleDownload} onReset={handleReset} />
  );
});
